<template>
    <div class="third service-visitcount-basicpage">
	    <div class="third-rea">
            <div class="third-btn">
                <div class="btn-left">检索条件</div>
                <div class="btn-right">
                    <el-button class="btn-two" type="primary" @click="searchHeader">查询</el-button>
                    <el-button class="btn-two" type="default" @click="reset">重置</el-button>
                    <span class="btn-shu"></span>
                    <el-button class="btn-four" type="default" icon="el-icon-search" @click="hignSearch">高级检索</el-button>
                </div>
            </div>
            <div class="third-search">
                <el-form :inline="true" :model="searchForm" label-width="76px">
                    <div class="search-row">
                        <div class="row-item">
                            <el-form-item label="服务名称">
                                <el-input
                                    class="item-input"
                                    :maxlength="30"
                                    v-model.trim="searchForm.serviceName"
                                    placeholder="请输入"
                                    @keyup.enter.native="searchHeader">
                                </el-input>
                            </el-form-item>
                        </div>
                        <div class="row-item">
                            <el-form-item label="服务状态">
                                <el-select class="item-input" v-model="searchForm.status" placeholder="请选择">
                                    <el-option label="全部" value=""></el-option>
                                    <el-option label="已下架" value="0"></el-option>
                                    <el-option label="已上架" value="1"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
            </div>
		</div>
		<div class="third-one">
            <div class="third-do-btn">
                <div class="do-btn-right">
                    <div class="do-btn-hign-list" >
                        <display-field
                            :selectList="tableRow"
                            sessionOriginalName="otherDisplayFiedOrignal_service-visitcount-basicpage"
                            @setDataOrder="getDataOrder"
                            sessionResultName="otherDisplayFied_service-visitcount-basicpage"
                        ></display-field>
                    </div>
                </div>
            </div>
            <div>
                <el-table
                    class="third-tableThree"
                    :data="tableData"
                    border
                    stripe
                    v-loading="tableLoading"
                    ref="otherTableBasic"
                    row-key="otherUserId">
                    <template v-for="(val,key) in tableDataShow">
                        <el-table-column
                            v-if="val.needKeyValue"
                            min-width="100px"
                            :prop="val.key"
                            :label="val.column"
                            :key="key"
                            :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <span style="color:red;" v-if="scope.row.status == 0">已下架</span>
                                <span style="color:#33CC99" v-if="scope.row.status == 1">已上架</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-else
                            min-width="100px"
                            :prop="val.key"
                            :label="val.column"
                            :key="key"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                    </template>
                </el-table>
                <div class="third-page">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        background
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                    </el-pagination>
                </div>
            </div>
		</div>

		<hign-modal
			:hignModalVisible="hignModal"
			@searchModal="toHignSearch"
			@cancelModal="closeModal"
			:hignOneList="tableRow">
		</hign-modal>
	</div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { removeStore, setStore, getStore } from "@/utils/store";
import { cloneDeep } from "lodash";
export default {
	name: "BasicPage",
	data() {
		return {
            tableLoading: false,
            pageSize: 40,
            currentPage: 1,
            total: 0,
            tableData: [],
            hignModal: false, // 高级搜索
            searchForm: {
                serviceName: '', // 名称
                status: '', // 状态
            },
            checked: true,
            noticeModal: false, // 提示弹窗
            noticeType: 1, // 提示类型
            noitceContent: "是否确认删除？", // 提示信息
            noticeTitle: "确认操作", // 提示
            deleteRow: {}, // 单个删除行
            deleteList: [], // 多行删除
            keyIdList: [],
            type: "single",
            orderConfig: '', // 顺序设置
            tableDataShow: [], // 表格行设置
            hignSearchRes: '', // 高级检索条件
            tableRow: [
                {
                    column: "服务名称",
                    key: "serviceName",
                    needKeyValue: false,
                    caseKey: "service_name"
                },
                {
                    column: "历史访问次数",
                    key: "count",
                    needKeyValue: false,
                    caseKey: "count"
                },
                {
                    column: "服务创建时间",
                    key: "createTime",
                    needKeyValue: false,
                    caseKey: "create_time"
                },
                {
                    column: "最近访问时间",
                    key: "newTime",
                    needKeyValue: false,
                    caseKey: "new_time"
                },
                {
                    column: "服务状态",
                    key: "status",
                    needKeyValue: true,
                    caseKey: "status",
                    isCustomList: [
                        {
                        label: '已上架',
                        value: '1'
                        },
                        {
                        label: '已下架',
                        value: '0'
                        }
                    ]
                },
            ],
            countNum: 1, // 只显示第一条错误信息
		};
	},
	created() {
		const dispField = this.getSessonValue("otherDisplayFied");
		const tableRow = this.getSessonValue("otherSortData");
		if (dispField) {
		    this.orderConfig = dispField;
		}
		if (tableRow) {
		    this.tableDataShow = tableRow;
		} else {
		    this.tableDataShow = this.tableRow;
        }
    },
    mounted () {
        this.searchHeader();
    },
	computed: {
		...mapState({
		    userInfo: state => state.user.userInfo
		})
	},
	methods: {
        ...mapMutations({
            changeComponentName: "SET_visitCountComponentName"
        }),
        ...mapActions([
            'visitCountList',
        ]),
		// 高级检索
		async toHignSearch(res) {
            this.currentPage = 1;
            this.hignSearchRes = res;
            this.hignModal = false;
            this.search()
		},
		getDataOrder(value) {
            this.orderConfig = value;
            this.search();
		},
		reset() {
            this.currentPage = 1;
            Object.assign(this.searchForm, this.$options.data().searchForm);
            this.hignSearchRes = ''
            this.search();
        },
        searchHeader() {
            this.currentPage = 1;
            this.search();
        },
		async search() {
            this.tableLoading = true
            this.searchForm.serviceName = this.searchForm.serviceName.trim()
            let params = [
                {
                    current: this.currentPage,
                    size: this.pageSize,
                },
                {
                    serviceName: this.searchForm.serviceName,
                    status: this.searchForm.status,
                    advancedSearch: this.hignSearchRes,
                    dataSortStr: this.orderConfig,
                }
            ]
            const {
                data: { result, msg, status }
            } = await this.visitCountList(params)
            this.tableLoading = false
            if (status === 1000) {
                console.log(result)
                // this.tableData = result.records
                // this.total = Number(result.total)
                if (result.records.length !== 0) {
                    this.tableData = result.records
                    this.total = Number(result.total)
                } else {
                    if (this.currentPage !== 1) {
                        this.currentPage -= 1
                        this.search()
                    } else {
                        this.tableData = []
                        this.total = 0
                    }
                }
                return
            }
            this.tableData = []
            this.total = 0
            this.$message.error(msg);
		},
        // 验证
        validateTwo(prop, msgStatus, validateMessage) {
            // console.log(prop, msgStatus, validateMessage)
            if (!msgStatus && !this.countNum) {
                this.countNum += 1;
                if (validateMessage) {
                    this.$message.error(validateMessage)
                }
            }
        },
		// 显示高级或者不显示
		changeHign() {
		    console.log(this.checked);
		},
		// 关闭弹窗
		closeModal() {
		    this.hignModal = false;
		},
		// 高级检索
		hignSearch() {
		    this.hignModal = true;
        },
        getSessonValue(name) {
            return getStore({
                name: name,
                type: "session"
            });
        },
        //条数变化
        handleSizeChange(val) {
            this.currentPage = 1;
            this.pageSize = val;
            this.search();
        },
        //页码变化
        handleCurrentChange(val) {
            this.currentPage = val;
            this.search();
        },
	}
};
</script>
<style lang="scss">
.service-visitcount-basicpage {
	.third-tableThree {
		.el-table__body-wrapper {
			height: calc(100vh - 193px) !important;
		}
	}
    .el-form-item__label {
        margin-right: 10px;
    }
}
</style>
